<template>
  <!--<div class="home">-->
    <!--<img src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--</div>-->
    <div class="wrap">
        <h1>프로필 관리</h1>
        <div class="doctor-view-wrap">
            <div class="dr-profile">
                <h2>기본 정보</h2>
                <!-- img -->
                <div class="dr-profile-box clearfix">
                    <div class="profile-img">
                        <p class="profile-img-wrap" :title="img_title_view(this.preview_pharm_img)">
                            <img v-if="preview_pharm_img" :src="preview_pharm_img">
                            <!--<img src="../assets/home/profile-default.jpg" alt="프로필 이미지" title="프로필 이미지">-->
                        </p>
                        <div class="profile-img-change">
                            <a @click.prevent="upload_button_click(0)"><icon name="camera" class="camera-icon" title="프로필이미지"></icon></a>
                            <input type="file" name="babo2" ref="fileInput0" style="display: none" @change="pharm_img_change" accept="image/*" capture="filesystem" />
                            <!--<input type="file" name="babo2" ref="fileInput" style="display: none" @change="img_add"/>-->
                        </div>
                    </div>
                    <div class="profile-name">
                        <h4 class="name">{{ pharm.pharm_name }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="hospital-view-wrap">
            <div class="dr-profile">
                <!-- txt -->
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">(정식)약국명</div>
                    <div class="profile-txt profile-txt-rt"><input type="text" name="hospital-name" id="hospital-name" v-model="pharmacy.pharm_name"></div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">{{pharmacy.addr_short}}주소</div>
                    <div class="profile-txt profile-txt-rt">
                      <select id="addr_short" name="addr_short" v-model="pharmacy.addr_short">
                        <option v-for="row in locationCodes" :value="row" :key="row.idx">{{ row }}</option>
                      </select>
                      <button type="button" class="location-serach-btn" @click.prevent="locationPopup()">주소검색</button>
                      <input type="text" name="hospital-pos" id="hospital-pos" v-model="pharmacy.location" readonly>
                      <input type="text" name="addr_detail" id="addr_detail" v-model="pharmacy.addr_detail">
                    </div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">전화번호</div>
                    <div class="profile-txt profile-txt-rt">
                        <ContactInput v-model="pharmacy.pharm_tel" class="contact-test"></ContactInput>
                    </div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">팩스번호</div>
                    <div class="profile-txt profile-txt-rt">
                        <ContactInput v-model="pharmacy.pharm_fax" class="contact-test"></ContactInput>
                    </div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">대표약사명</div>
                    <div class="profile-txt profile-txt-rt"><input type="text" name="hospital-dr-name" id="hospital-dr-name" v-model="pharm.pharmacy_pharm_name"></div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">이메일</div>
                    <div class="profile-txt profile-txt-rt"><input type="text" name="hospital-dr-email" id="hospital-dr-email" v-model="pharm.email"></div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">휴대폰</div>
                    <div class="profile-txt profile-txt-rt"><input type="text" name="hospital-tel" id="hospital-tel" v-model="pharm.contact"></div>
                    <!-- <div class="profile-txt profile-txt-rt">
                        <ContactInput v-model="pharm.contact" class="contact-test"></ContactInput>
                    </div> -->
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">담당자</div>
                    <div class="profile-txt profile-txt-rt">
                        <manager v-model="pharm.pharmacist_arr" @set_new_manager_arr="set_new_manager_arr"></manager>
                    </div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">사업자등록증</div>
                    <div class="profile-txt profile-txt-rt">
                        <div class="profile-copy-img">
                        <p class="profile-copy-img-wrap">
                            <img v-if="preview_license_img" :src="preview_license_img">
                        </p>
                        <div class="profile-copy-img-change">
                            <a @click.prevent="upload_button_click(1)"><icon name="camera" class="camera-icon" title="약사면허증이미지"></icon></a>
                            <input type="file" name="license_img" ref="fileInput1" style="display: none" @change="pharm_license_img_change" accept="image/*" capture="filesystem" />
                        </div>
                    </div>
                    </div>
                </div>
                

            </div>
        </div>
        <div class="profile-btn">
            <button type="button" @click="save_all">프로필저장</button>
        </div>

        <div id="myModal" class="modal" v-if="is_modal">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="close" @click="justClosePopup()">&times;</span>
                    <h1>주소 검색</h1>
                </div>
                <div class="modal-body">
                    <Location @closeEvent="closeLocationPopup"></Location>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { mapState } from 'vuex'
import Manager from '@/components/ProfileEdit/Manager.vue'
import ContactInput from '@/components/Common/ContactInput.vue'
import Upload from '@/lib/upload'
import {UPLOAD_TYPE} from '@/lib/constants'
import { nameByConstMixin } from '@/lib/mixins'
import Location from '@/components/Common/Location.vue'

export default {
  mixins: [nameByConstMixin],
  name: 'profile-edit',
  data () {
    return {
      pharmacy: {
        pharm_id: '',
        pharm_name: '',
        pharm_tel: '',
        pharm_fax: '',
        location: '',
        pharm_imgs: [], // 서버에서 내려주는 가공된 이미지 데이터(W/ URL)
        del_imgs: [], // 삭제할때는 이 image hash_id
        uploaded_files: [], // 업로드가 있을때만 보낸다.
        addr_short: null,
        addr_detail: '',
      },
      pharm: {
        pharm_id: null,
        pharm_name: null,
        email: null,
        contact: null,
        pharm_img: null,
        pharm_img_sm: null,
        pharm_intro: null,
        pharm_intro_url: null,
        pharmacy_id: null,
        rec_stars: 0, // 이거 필요한가?
        pharmacy_pharm_name: null,
        pharm_imgs: [], // 서버에서 내려주는 가공된 이미지 데이터(W/ URL)
        del_imgs: [], // 삭제할때는 이 image hash_id
        uploaded_files: [], // 업로드가 있을때만 보낸다.
        is_overseas_on: 0, //영어 상담 가능 여부
        latitude: '',
        longitude: '',
        pharmacist: [],
        pharmacist_tel: [],
        pharmacist_arr: [],
      },
      upload_obj: null, // 프로파일 이미지
      preview_pharm_img: '',
      preview_license_img: '',
      inputVisible: false,
      inputValue: '',
      locationCodes: [], //지역 필터 검색시 필요함, 지역 필터 검색 코드를 불러옴
      is_modal: false, //주소검색 modal popup
    }
  },
  computed: {
    ...mapState(['account']),
  },
  methods: {
    upload_button_click (img_type) {
      if(img_type == 0) this.$refs.fileInput0.click();
      else if(img_type == 1) this.$refs.fileInput1.click();
    },
    onDelImg(img_bash_id) {
      this.pharmacy.del_imgs.push(img_bash_id)
    },
    onDelImgDr(img_bash_id) {
      this.pharm.del_imgs.push(img_bash_id)
    },
    async getPharmData (pharm_id) {
      let chosen_fields = Object.keys(this.pharm)
      let {data: {resp}} = await this.axios.get(`pharmacist/${pharm_id}`)

      for (let key of chosen_fields) {
        if (key in resp) {
          this.pharm[key] = resp[key]
        }
      }

      this.preview_pharm_img = resp.pharm_img_sm
      this.preview_license_img = resp.license_img
    },
    async getPharmacyData (pharm_id) {
      let chosen_fields = Object.keys(this.pharmacy)
      let {data: {resp}} = await this.axios.get(`pharmacy/${pharm_id}`)
      //console.log('getHospData')

      for (let key of chosen_fields) {
        if (key in resp) {
          this.pharmacy[key] = resp[key]
        }
      }

      //alert(this.pharmacy.manager)
    },
    async location_list () {  //전문 진료 분야 가져오기 20190411 kjw
        
        await this.axios({
          method: 'get',
          url: '/appdata/code/21', //앱에서 필터검색에 사용하는 코드
          //data: params,
          params: {code: 12},
        }).then((response) => {
          //console.log(response);
          if(response.data.status == '200'){
            let locationStr = response.data.resp[0].subject;
            
            if(locationStr){
              this.locationCodes = locationStr.split(',');
            }
          }else{
            //alert('오류가 발생 했습니다.');
          }
        }).catch((error) => {
            console.log('error!: ', error);
        });
    },
     pharm_img_change (event) {
      let file_kind = event.target.name;
      let upload_files = event.target.files;

      const reader = new FileReader();

      reader.onload = (e) => {
        this.preview_pharm_img = e.target.result;
      }
      reader.readAsDataURL(upload_files[0])

      this.upload_obj = new Upload(UPLOAD_TYPE.PHARM_IMG, {key_id: this.pharm.pharm_id, resize_width: 400})

      for (let file of upload_files) {
        // formData.append(file_kind, file)
        this.upload_obj.append(file)
      }
    },
    pharm_license_img_change (event) {
      let file_kind = event.target.name;
      let upload_files = event.target.files;

      const reader = new FileReader();

      reader.onload = (e) => {
        this.preview_license_img = e.target.result;
      }
      reader.readAsDataURL(upload_files[0])

      this.upload_obj = new Upload(UPLOAD_TYPE.PHARM_IMG, {key_id: this.pharm.pharm_id, resize_width: 400})

      for (let file of upload_files) {
        // formData.append(file_kind, file)
        this.upload_obj.append(file)
      }
    },
    async img_upload (key_id, resize_width) {
      let upload = new Upload(UPLOAD_TYPE.PHARM_IMG, {key_id, resize_width})

      for (let [idx, [img_seq, img_url, file_obj]] of this.pharmacy.pharm_imgs.entries()) {
        if (img_seq === 'new') {
          upload.append(file_obj)
          // form.append('hosp', file_obj)
          // console.log('img_upload')
          // console.log('idx, [img_seq, img_url, file_obj]', idx, img_seq, img_url, file_obj)
          this.pharmacy.pharm_imgs[idx] = 'uploaded' // 중복저장을 막기 위해서 처리.
        }
      }

      let resp = await upload.done()
      return resp.uploaded_sm_files
    },
    async img_upload_dr (key_id, resize_width) {
      let upload = new Upload(UPLOAD_TYPE.PHARM_IMG, {key_id, resize_width})

      for (let [idx, [img_seq, img_url, file_obj]] of this.pharm.pharm_imgs.entries()) {
        if (img_seq === 'new') {
          upload.append(file_obj)
          // form.append('hosp', file_obj)
          // console.log('img_upload')
          // console.log('idx, [img_seq, img_url, file_obj]', idx, img_seq, img_url, file_obj)
          this.pharm.pharm_imgs[idx] = 'uploaded' // 중복저장을 막기 위해서 처리.
        }
      }

      let resp = await upload.done()
      return resp.uploaded_sm_files
    },
    async createPharmacy (pharm_data) {
      let new_data = Object.assign({}, this.pharmacy, pharm_data) // 꼭 state는 Object.assign 으로 데이터를 빼줘야 한다.
      delete new_data.pharm_imgs // 보기 전용 데이터 임으로 삭제한다. (payload 크기 413 문제로 꼭 지워줘야 한다)

      // {"status":200,"resp":{"uploaded_files":["101001_0.jpg"],"uploaded_urls":["http://127.0.0.1:3000/static/hosp/101001/101001_0.jpg"]},"has_error":false}
      let {data: {resp}} = await this.axios.post('pharmacy', new_data)
      return resp.pharm_id
    },
    async save_pharmacy (pharm_data) { // 부분 업데이트가 필요하다.
      if (!pharm_data.pharm_id) throw new Error('save_pharmacy : pharm_id가 존재하지 않습니다.')

      let post_data = Object.assign({}, pharm_data)
      delete post_data.pharm_imgs

      await this.axios.post(`pharmacy/${pharm_data.pharm_id}`, post_data)
    },
    async save_pharmacist (pharm_data) {
      if (!pharm_data.pharm_id) throw new Error('save_pharmacist: pharm_id가 존재하지 않습니다')

      let post_data = Object.assign({}, pharm_data)
      delete post_data.pharm_imgs
      await this.axios.post(`pharmacist/${pharm_data.pharm_id}`, post_data)
    },
    async save_all () {
      if (this.pharmacy.pharm_id) { // 약국 레코드 존재
        // console.log('약국정보 있음')
        let uploaded_sm_files = await this.img_upload(this.pharm.pharm_id, 800)
        this.pharmacy.uploaded_files = uploaded_sm_files
        // 의사쪽에도 넣어주기.
      } else {
        // console.log('약국정보 없음', this.pharmacy)
        let pharmacy_id = await this.createPharmacy(this.pharmacy)
        // console.log('pharmacy_id', pharmacy_id)
        this.pharm.pharmacy_id = pharmacy_id
        this.pharmacy.pharm_id = pharmacy_id

        let uploaded_sm_files = await this.img_upload(pharmacy_id, 800)
        this.pharmacy.uploaded_files = uploaded_sm_files
      }

      if (this.upload_obj) {
        let resp1 = await this.upload_obj.done()

        let [hash_key, filename] = resp1.uploaded_files[0]
        this.pharm.pharm_img = filename

        let [hash_key2, filename2] = resp1.uploaded_sm_files[0]
        this.pharm.pharm_img_sm = filename2
      } else {
        delete this.pharm.pharm_img // 원본 필드명과 같이 사용하다 보니 서버에서 내려온 http:// 시작하는 주소가 덮어써지는걸 방지하기 위해서
        delete this.pharm.pharm_img_sm
      }

      //의사 소개 이미지 추가 20191029 kjw
      let uploaded_sm_files_dr = await this.img_upload_dr(this.pharm.pharm_id, 800)
      this.pharm.uploaded_files = uploaded_sm_files_dr

      this.save_pharmacy(this.pharmacy)
      this.save_pharmacist(this.pharm)
      // console.log('this.pharm', this.pharm)
      alert('저장완료')
      this.$router.push(`/profile`)

    },
    img_click() { 
      const url = this.pharm.pharm_intro_url;
      window.open(url,"","width=800,height=600")
    },
    async set_manager_arr(){
      let managerTempArr = new Array();
      
      if(this.pharm.pharmacist.length > 0){
        for(let i=0; i<this.pharm.pharmacist.length; i++){
          let managerObj = new Object();
          managerObj.manager = this.pharm.pharmacist[i];
          managerObj.manager_tel = this.pharm.pharmacist_tel[i];
          
          if(this.pharm.pharmacist_tel.length > 0){
            let split = this.pharm.pharmacist_tel[i].split('-');
            if(split.length >= 3){
              managerObj.manager_tel1 = split[0];
              managerObj.manager_tel2 = split[1];
              managerObj.manager_tel3 = split[2];
            }else{
              managerObj.manager_tel1 = '';
              managerObj.manager_tel2 = '';
              managerObj.manager_tel3 = '';
            }
          }
          managerTempArr.push(managerObj);
        }
      }
      this.pharm.pharmacist_arr = managerTempArr;
    },
    async set_new_manager_arr(name, tel){
      //Manager컴포넌트에 manager_arr배열로 넘겨줬던 
      //manager, manager_tel이 변경될때마다(watch) 값을 다시 받아 manager, manager_tel에 변경된 값 할당
      this.pharm.pharmacist = name;
      this.pharm.pharmacist_tel = tel;
    },
    async locationPopup(){
      this.is_modal = true;
    },
    async closeLocationPopup(event) {
      // console.log(event);

      if(event.address){
        this.pharmacy.location = event.address;
        
        //위경도 받기
        let params = {
          'address': this.pharmacy.location,
        }
        let today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth() + 1;  // 월
        let date = today.getDate();  // 날짜
        let secure_key = (month + date) * 12;
        
        await this.axios({
          method: 'get',
          url: 'https://api-v2.mdtalk.io/geolocation/' + secure_key + '/lat_lng_from_addr/',
          params: params,
          headers: {'Authorization': 'Token 26c42293dd1fd5ed01320646e094196a827393f8'}
        }).then((response) => {
          this.pharm.latitude = response.data.resp.lat;
          this.pharm.longitude = response.data.resp.lng;
        }).catch((error) => {
          console.log('error: ', error);
          alert('주소가 정확하지 않습니다. 확인해 주세요');
          return false;
        });
      }
      this.is_modal = false;
    },
    async justClosePopup(){
      this.is_modal = false;
    }
  },
  async mounted () {
    await this.getPharmData(this.account.pharm_id)
    await this.getPharmacyData(this.pharm.pharmacy_id)
    await this.set_manager_arr()
    await this.location_list()
  },
  components: {
    ContactInput, Manager, Location
  }
}
</script>

<style scoped>
    /* Contents
    ------------------------------------------------------- */
    .wrap {
        width: 100%;
        max-width: 1280px;
        margin: 55px auto;
    }

    .wrap > h1 {
        color: #494949;
        margin-bottom: 30px;
        letter-spacing: -.5px;
        font: 400 24px 'Noto Sans KR', sans-serif;
    }

    .wrap > div {
        width: 100%;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
    }

    .doctor-view-wrap,
    .hospital-view-wrap {
        padding: 30px;
    }
    
    .doctor-view-wrap {
        margin-bottom: 10px;
    }

    .wrap .profile-btn {
        width: 160px;
        height: 50px;
        margin: 20px auto;
    }

    .wrap .profile-btn button {
        color: #8d8d8d;
        width: 100%;
        height: 100%;
        border: none;
        padding: 0;
        outline: 0;
        cursor: pointer;
        background-color: transparent;
        font: 400 18px/48px 'Noto Sans KR', sans-serif;
    }

    .profile-list-add-btn {
        color: #fff;
        background-color: #d8d8d8;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    li > button {
        width: 80px;
        height: 50px;
        padding: 0;
        border: none;
        cursor: pointer;
        margin-left: 10px;
        position: relative;
        background-color: transparent;
    }

    .dr-profile > h2 {
        color: #474747;
        margin-bottom: 40px;
        letter-spacing: -.5px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .dr-profile-box:first-of-type {margin-bottom: 10px;}
    .dr-profile-box:nth-of-type(n+2) {margin-bottom: 10px;}

    .dr-profile-box > div {
        float: left;
    }
    .dr-profile-box .sub-txt dt{float:left; line-height:50px; margin-right:10px;}
    .dr-profile-box .sub-txt dd{overflow:hidden;}
    .dr-profile-box .sub-txt textarea{border-color:#d2d2d2;}

    #addr_short {
      width: 10%;
      padding: 0 15px;
      font: 400 14px 'Noto Sans KR', sans-serif;
      background: url(../assets/home/select.png) 95% no-repeat;
    }

    .location-serach-btn {
      color: #fff;
      width: 80px;
      padding: 0 15px;
      margin-right: 10px;
      background-color: #d8d8d8;
      font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .profile-img,
    .profile-txt-lt {
        width: 170px;
        position: relative;
    }

    .profile-copy-img {
        /* width: 150px; */
        position: relative;
    }

    .profile-img > p {
        display: block;
        height: 120px;
        width: 120px;
        margin: 0 auto 10px;
        border-radius: 50%;
        background-image: url('../assets/home/profile-default.jpg');
    }

    .profile-copy-img > p {
        display: block;
        height: 120px;
        width: 120px;
        margin: 0 auto 10px;
        /* border-radius: 50%; */
        /* background-image: url('../assets/home/profile-default.jpg'); */
    }

    .profile-img img {
        width: 100%
    }

    .profile-copy-img img {
        width: 100%
    }

    .profile-img-wrap {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #ccc;
        font-size: 10px;
        overflow: hidden;
    }

    .profile-copy-img-wrap {
        width: 60px;
        height: 60px;
        /* border-radius: 50%; */
        background-color: #ccc;
        font-size: 10px;
        overflow: hidden;
    }


    .profile-img-change {
        height: 30px;
        width: 30px;
        background-color: white;
        border: 1px solid #e5e5e5;
        text-align: center;
        line-height: 38px;
        border-radius: 50%;
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    .profile-copy-img-change {
        height: 30px;
        width: 30px;
        background-color: white;
        border: 1px solid #e5e5e5;
        text-align: center;
        line-height: 38px;
        /* border-radius: 50%; */
        position: absolute;
        bottom: 15px;
        right: 5px;
    }

    .profile-name .cate {
        display: inline-block;
        color: #6e6fe5;
        padding: 2px 20px;
        box-sizing: border-box;
        border: 1px solid #6e6fe5;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .profile-name .name {
        margin: 7px 0 5px;
        font: 500 32px 'Noto Sans KR', sans-serif;
    }

    .profile-name .recommend > p,
    .profile-name .recommend > span {
        float: left;
        color: #676767;
    }

    .profile-name .recommend > p {
        text-indent: 25px;
        font: 500 14px 'Noto Sans KR', sans-serif;
        background: url(../assets/home/star.png) 0 center/18px no-repeat;
    }

    .profile-name .recommend > span {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 5px 0 0 7px;
        text-align: center;
        border: 1px solid #999;
        border-radius: 50%;
        box-sizing: border-box;
        font: 600 8px/14px 'Noto Sans KR', sans-serif;
    }

    .call-br {margin: 0 10px;}

    #call-num1,
    .txt-rt select {
        padding: 0 15px;
        background: url(../assets/home/select.png) 90% center/10% no-repeat;
    }

    .dr-profile-box {margin-bottom: 30px;}
    .dr-profile-box:last-of-type {margin-bottom: none;}

    .profile-txt {
        color: #454545;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }   

    .profile-txt-lt {
        width: 170px;
        text-indent: 20px;
        line-height: 50px;
    }

    .profile-txt-rt {width: 900px;}
    .profile-txt-rt em {color: #bcbcbc; margin-left: 10px;}
    .profile-txt-rt li {height: 50px; margin-bottom: 10px; line-height: 50px;}
    .profile-txt-rt li:last-child {margin-bottom: none;}

    .profile-txt-rt input,
    .profile-txt-rt select {
        height: 50px;
        padding: 0 10px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .profile-txt-rt > input {width: 80%;}
    .profile-txt-rt li > input {width: 70%;}

    .profile-txt-rt li > input,
    .profile-txt-rt li > button {float: left;}

    /* #hospital-name, #hp-url {width: 30%;} */
    /* #hospital-intro, #category {width: 45%;} */

    .profile-txt-rt > div {float: left;}
    .profile-txt-rt > div li {margin-bottom: 40px;}
    .profile-txt-rt > div li:last-child {margin-bottom: 0;}
    .profile-txt-rt .txt-lt {width: 100px;}
    .profile-txt-rt .txt-rt {width: 800px; color: #000;}

    .txt-rt select {
        width: 15%;
        color: #c8c8c8;
    }

    #add-info {width: 620px;}

    #hospital-intro {
      width:78%;
      padding: 10px;
      border:1;
      overflow:visible;
      text-overflow:ellipsis;
      font: 400 14px 'Noto Sans KR', sans-serif;
    }

    #note-info {
      width:598px;
      padding: 10px;
      border:1;
      overflow:visible;
      text-overflow:ellipsis;
      margin-bottom: 5px;
      font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .upload-notice {
        color: #999;
        margin: 0 0 0 170px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .h2-notice {
        color: #999;
        margin: 0 0 0 10px;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    #hospital-pos {
        color: #000;
        width: 29%;
        background: rgb(220, 220, 220);
    }

    #addr_detail {
        margin-left: 10px;
        color: #000;
        width: 29%;
    }

    /* tag 관련 CSS */

      .el-tag {
        margin-top:10px;
        margin-right: 10px;
      }
      .button-new-tag {
        /* margin-left: 10px; */
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
        margin-top:10px;
      }
      .input-new-tag {
        width: 90px;
        height: 32px;
        line-height: 30px;
        margin-right: 10px;
        margin-top:10px;
        vertical-align:top;
      }

    .camera-icon {
        color: #a1a1a1
    }

    .profile-txt-rt > button {
        color: #fff;
        width: 80px;
        height: 50px;
        background-color: #d8d8d8;
        font: 400 16px 'Noto Sans KR', sans-serif;
        padding: 0;
        border: none;
        cursor: pointer;
        margin-left: 10px;
        position: relative;
    }
/* 
    .txt-rt > li > textarea{
      display:block;
      width:400px; 
      height:100px;
      padding:10px;
      font:400 14px Noto Sans KR,sans-serif;
      text-align:left;
      word-break:keep-all;

    } */

    
    
    /* The Modal (background) */
    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        opacity:0.99;
        z-index: 100; /* Sit on top */
        padding: 0; /* Location of the box */
        left: 0;
        top: 0;
        width: 100% !important; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(9,9,9) !important; /* Fallback color */
        background-color: rgba(0,0,0,0.4) !important; /* Black w/ opacity */
    }

    /* Modal Content */
    .modal-content {
        position: relative;
        background-color: #fefefe;
        margin: auto;
        margin-top: 100px;
        padding: 0;
        border: 1px solid #888;
        width: 700px;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }
    .modal-header {
        padding: 5px 20px;
        background-color: #111;
        color: white;
    }

    .modal-body {padding: 0px 0px;}

    .modal-footer {
        padding: 2px 10px;
        background-color: #111;
        color: white;
    }

    .close {
        color: white;
        float: right;
        font-size: 30px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .modal-header h1 {
        margin-bottom: 10px;
        font: 400 20px 'Noto Sans KR', sans-serif;
    }

    .modal-header {
        padding: 10px 20px;
        background-color: #111;
        color: white;
    }

    .modal-body {padding: 10px 20px;}

    .modal-footer {
        padding: 2px 10px;
        background-color: #111;
        color: white;
    }

</style>
